function zeroPad(i) {
    if (i <= 9) return `0${i}`;
    return i;
}
export function jsDateToIsoDate(d: Date, separator = '-') {
    return d.getFullYear() + separator + zeroPad(d.getMonth() + 1) + separator + zeroPad(d.getDate());
}